module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style8/accordian-style8.component.scss
// module id = ./src/app/features/accordian/accordian-style8/accordian-style8.component.scss
// module chunks = main